module.exports = __webpack_public_path__ + "9402f42fe6784c903848f2aca1603949.png";